import type { AxiosInstance } from 'axios';
import axios from 'axios';

import { API_URL } from 'env';

export const axiosInstance: AxiosInstance = axios.create({
    baseURL: API_URL,
    timeout: 15000,
});
